import { render } from "./LoginSignup.vue?vue&type=template&id=ffcc65ac"
import script from "./LoginSignup.vue?vue&type=script&lang=js"
export * from "./LoginSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__